import { createListenerMiddleware } from '@reduxjs/toolkit';
import { addMiddleware } from 'redux-dynamic-middlewares';
import TypeaheadLocationType  from 'enums/typeaheadLocationType';
import { searchParametersSlice } from './slices';

const { actions } = searchParametersSlice;

const listenerMiddleware = createListenerMiddleware();

// Handling the redirection as a side effect of the fetchLocations action
// This listener is in charge to redirect to the community detail page when a community location is 
// selected from the search results page.
listenerMiddleware.startListening({
  type: actions.fetchLocations.type,
  effect: (action) => {
    const isCommunity = action?.payload?.locationType?.toLowerCase() === TypeaheadLocationType.Community.toString();
    const isMasterPlannedCommunity = action?.payload?.locationType?.toLowerCase() === 
    TypeaheadLocationType.MasterPlannedCommunity.toString().toLowerCase();

    if (isCommunity || isMasterPlannedCommunity) {
      window.location.href = `/communitydetail/community-${action?.payload?.communityId}`
    }
  },
});

addMiddleware(listenerMiddleware.middleware);